module.exports = __webpack_public_path__ + "static/media/036-man-9.37961fe6.svg";